export default __webpack_public_path__ + "static/media/back.e0c94bd4.jpg";